<!-- Vehicle Management -->
<div class="d-flex flex-column flex-column-fluid">
  <!-- Vehicle Listing Component -->
  <router-outlet></router-outlet>
</div>

<!-- Vehicle Update Modal -->
<app-vh-manager-update
  (vehicleUpdated)="onVehicleUpdated()">
</app-vh-manager-update>

<!-- Masho Manager Add/Edit Modal -->
<app-masho-manager-add-edit
  (mashoAdded)="onMashoAdded()"
  (mashoUpdated)="onMashoUpdated()">
</app-masho-manager-add-edit>

<!-- Vehicle Remarks Modal -->
<app-vh-manager-vehicle-remarks
  (remarkAdded)="onRemarkAdded()">
</app-vh-manager-vehicle-remarks>

<!-- Transport Pickup Add/Edit Modal -->
<app-transport-pickup-add
  (transportPickupAdded)="onTransportPickupAdded()"
  (transportPickupUpdated)="onTransportPickupUpdated()">
</app-transport-pickup-add>

<!-- Vehicle Price Sheet Modal -->
<app-vh-price-sheet
  (priceSheetSaved)="onPriceSheetSaved()">
</app-vh-price-sheet>

<!-- Vehicle Upload Images Modal -->
<app-vh-manager-upload-images
  (imagesUploaded)="onImagesUploaded()">
</app-vh-manager-upload-images>

<!-- Export Certificate Modal -->
<app-vh-manager-export-certificate
  (certificateGenerated)="onCertificateGenerated($event)">
</app-vh-manager-export-certificate>

<!-- Purchase Manager Add/Edit Modal -->
<app-add-edit-purchase-manager
  (purchaseManagerAdded)="onPurchaseManagerAdded()"
  (purchaseManagerUpdated)="onPurchaseManagerUpdated()">
</app-add-edit-purchase-manager>
